import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { acceptor } from "../type";

const initialState: Partial<acceptor> = {};

export const acceptorSlice = createSlice({
  name: "acceptor",
  initialState,
  reducers: {
    setAcceptor: (state, action: PayloadAction<acceptor>) => {
      return action.payload;
    },
  },
});
export const { setAcceptor } = acceptorSlice.actions;
export default acceptorSlice.reducer;
